import React from "react";

const FAQ = ({ onClose }) => {

  return null;
};

export default FAQ;

